const roles = {
	title: "Roles",
	new_role: "New Role",
	edit_role: "Edit Role: {name}",
	view_role: "View Role: {name}",
	detail_role: "Details",
	permission_role: "{name}: Set Permissions",
	list_title: "List of Roles",
	list_subtitle: "Manage roles",
	create_title: "Create New Role",
	update_title: "Update Role",
	permission_btn: "Permissions",
	id: "ID",
	name: "Name",
	slug: "Slug",
	type: "Type",
	check_all: "Check all",
	uncheck_all: "Uncheck all",
	check_all_access: "Check all (access)",
	check_all_create: "Check all (create)",
	check_all_edit: "Check all (edit)",
	check_all_delete: "Check all (delete)",
};
export default roles;